import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Providers from './providers/Providers';
import { msalInstance } from './utils/authConfig';
import './components/jspdf/embedPdfFonts';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

msalInstance.initialize()
  .then(() => {
    root.render(
      <Providers>
        <App />
      </Providers>
    );
  })
  .catch((error) => {
    console.error('MSAL initialization failed:', error);
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
